import * as React from "react"

const Container = ({ className, children }) => {
  return (
    <div className={`max-w-screen-xl mx-auto pr-6 pl-6 ${className}`}>
      {children}
    </div>
  )
}

export default Container
